import {
  Stack,
  Text,
  Button,
  useColorModeValue
} from '@chakra-ui/react'

import theme from '../../../../../Config/theme'

const FilterEssay = ({ state }) => {
  const { essay, setEssay } = state

  const buttonBgColor = useColorModeValue('gray.100', 'gray.800')

  const handleClick = (status) => {
    if (essay != status) {
      setEssay(!essay)
    }
  }

  return (
    <Stack direction={'column'}>
      <Text>Essay required?</Text>
      <Stack direction={'row'}>
        <Button
          _hover={{}}
          _active={{}}
          _focus={{}}
          bgColor={!essay ? theme.default.defaultColor : buttonBgColor}
          // color={'black'}
          w={'full'}
          onClick={() => handleClick(false)}
        >
          No
        </Button>
        <Button
          _hover={{}}
          _active={{}}
          _focus={{}}
          bgColor={essay ? theme.default.defaultColor : buttonBgColor}
          // color={'black'}
          w={'full'}
          onClick={() => handleClick(true)}
        >
          Yes
        </Button>
      </Stack>
    </Stack>
  )
}

export default FilterEssay